import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Loader } from '@lomarengas/design-system';
import { addStatusToast, SectionHeader } from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getTagDetails,
  initialTag,
  saveOrUpdateTag,
  selectTagDetails,
  updateTagDetails,
} from './tagsSlice';
import { LOADING_STATUS } from '../../common/constants';
import { TagForm } from './components/TagForm';
import { RootState } from '../../app/store';

function TagDetails() {
  const { tagId } = useParams<{ tagId: string }>();
  const backLinkUrl = '/accommodations/tags';
  const dispatch = useAppDispatch();
  const details = useAppSelector(selectTagDetails);
  const status = useAppSelector(
    (state: RootState) => state.accommodationTags.status,
  );

  useEffect(() => {
    if (tagId === 'new') {
      // initialize new TagDetails
      dispatch(updateTagDetails(initialTag));
    } else {
      // Fetch existing tag details from the server
      dispatch(getTagDetails(tagId));
    }
  }, [dispatch, tagId]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const updatedDetails = { ...details, [name]: value };
    dispatch(updateTagDetails(updatedDetails));
  };

  const handleSave = () => {
    dispatch(saveOrUpdateTag(details))
      .unwrap()
      .then((savedTagId: string) => {
        dispatch(
          addStatusToast({
            Message: `Tagin tiedot päivitetty.`,
          }),
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>Tagi</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Tagit']}
          Title={tagId === 'new' ? 'Uusi tagi' : details?.name}
          Children={
            <Button onClick={handleSave} variant="blue">
              Tallenna
            </Button>
          }
        />

        <Loader IsLoading={status === LOADING_STATUS.LOADING} />

        {status === LOADING_STATUS.IDLE && (
          <Container className="container-form mt-48">
            <Row>
              <Col>
                <TagForm
                  details={details}
                  handleInputChange={handleInputChange}
                />
              </Col>
            </Row>
          </Container>
        )}
      </Container>
    </>
  );
}

export default TagDetails;
